import { NewOrder } from '../../gql/graphql';
import { createForbiddenErrorMessage, createUnauthorizedErrorMessage } from '../../helpers/security/security';
import orderService from '../../services/order.service';
import { NetworkError } from '../../state-machine/actions/genericActions';

const createOrder = async (input: NewOrder) => {
  try {
    const result = await orderService.createOrder(input);

    return result;
  } catch (err: any) {
    var error = {} as NetworkError;
    switch (err?.networkError?.statusCode) {
      case 403:
        error.forbiddenError = createForbiddenErrorMessage(err);
        break;
      case 401:
        error.unauthorizedError = createUnauthorizedErrorMessage(err);
        break;
      default:
        error.errorGeneral = err;
    }
    throw error;
  }
};

export default createOrder;
